import React from "react";
import { List, ListItemIcon, ListItem, Grid, Box } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import lodash from "lodash";
import { Link } from "@reach/router";

export default function CustomList(props) {
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  const { data } = props;

  /**
  |--------------------------------------------------
  | Render
  |--------------------------------------------------
  */
  return (
    <List>
      {lodash.map(data, (item, idx) => (
        <Link key={`${idx} ${item.label}`} to={item.href}>
          <StyledListItem
            button
            style={
              item.label === props.selectedDealer.name
                ? { backgroundColor: "rgba(255,255,255,0.2)" }
                : {}
            }
          >
            {item.name && (
              <ListItemIcon>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  bgcolor="white"
                  width={40}
                  height={40}
                  borderRadius="100%"
                >
                  <Box color="black">{item.name.charAt(0)}</Box>
                </Box>
              </ListItemIcon>
            )}
            <Grid container>
              <Grid item xs={12}>
                <Box fontSize="1rem" color="white">
                  {item.label}
                </Box>
                <Box fontSize={12} color="grey.400">
                  {item.subtitle}
                </Box>
              </Grid>
            </Grid>
          </StyledListItem>
        </Link>
      ))}
    </List>
  );
}
/**
|--------------------------------------------------
| Default Props
|--------------------------------------------------
*/
CustomList.defaultProps = {
  data: [],
  selectedDealer: { name: null }
};

/**
|--------------------------------------------------
| Custom Styles
|--------------------------------------------------
*/
const StyledListItem = withStyles(theme => ({
  selected: {
    backgroundColor: `${theme.palette.primary.main} !important`
  }
}))(ListItem);
